/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function redirectTo(params) {
    var formatInput = function (options) { return ({
        url: options.url,
        method: 'GET',
        closeAfterOpen: true,
    }); };
    WVCall('AliWindow.open', params, { formatInput: formatInput });
}

export { redirectTo as default };
